/*
 * "Add Topture as a preferred source" buttons (snippets/preferred-source.liquid).
 *
 * Each [data-preferred-source="<placement>"] link points at Google's source-preferences page, which
 * stays the fallback. Google's publisher.js (39 KB gz) loads in manual mode only after window load
 * + idle, once the visitor allows analytics (window.tptConsent, snippets/consent-gate.liquid: the
 * script pings Google), and once a button comes near the viewport. After that a click opens
 * Google's pop-up flow instead and the visitor stays on the page.
 *
 * Reporting: `topture:preferred_source` on window, detail { action, placement }.
 *   action 'click' — every click, before either path runs.
 *   action 'added' | 'already_added' | 'ineligible' — the outcome of the pop-up flow. Google's API
 *   returns nothing to custom triggers, so it is read from the confirmation toast Google injects
 *   (iframe.publisher-toast, ?confirmationType=3|1|2). That URL is Google-internal: if it changes,
 *   outcomes stop reporting and clicks keep working. The plain-link path has no outcome.
 */
(function () {
  if (window.__tptPreferredSource) return;
  window.__tptPreferredSource = true;

  var GOOGLE_SCRIPT = 'https://news.google.com/swg/js/v1/publisher.js';
  var OUTCOMES = { 1: 'already_added', 2: 'ineligible', 3: 'added' };
  var OUTCOME_WAIT_MS = 10 * 60 * 1000;
  var api = null;

  function report(action, placement) {
    window.dispatchEvent(new CustomEvent('topture:preferred_source', {
      detail: { action: action, placement: placement }
    }));
  }

  function newToast() {
    var toasts = document.querySelectorAll('iframe.publisher-toast[src*="confirmationType="]');
    for (var i = 0; i < toasts.length; i++) {
      if (!toasts[i].__tptSeen) return toasts[i];
    }
    return null;
  }

  function markToastsSeen() {
    var toasts = document.querySelectorAll('iframe.publisher-toast');
    for (var i = 0; i < toasts.length; i++) toasts[i].__tptSeen = true;
  }

  function watchOutcome(placement) {
    markToastsSeen();
    var observer = new MutationObserver(function () {
      var toast = newToast();
      if (!toast) return;
      toast.__tptSeen = true;
      observer.disconnect();
      var match = /[?&]confirmationType=(\d+)/.exec(toast.src);
      if (match && OUTCOMES[match[1]]) report(OUTCOMES[match[1]], placement);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    setTimeout(function () { observer.disconnect(); }, OUTCOME_WAIT_MS);
  }

  function loadGoogle() {
    if (document.querySelector('script[src="' + GOOGLE_SCRIPT + '"]')) return;
    (self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push(function (preferredSource) {
      preferredSource.init();
      api = preferredSource;
    });
    var script = document.createElement('script');
    script.src = GOOGLE_SCRIPT;
    script.async = true;
    // Manual mode: publisher.js looks for this attribute and then skips its auto-rendered badges.
    script.setAttribute('preferred-sources-control', 'manual');
    document.head.appendChild(script);
  }

  function loadWhenNear(links) {
    if (!('IntersectionObserver' in window)) {
      loadGoogle();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        observer.disconnect();
        loadGoogle();
        return;
      }
    }, { rootMargin: '300px 0px' });
    Array.prototype.forEach.call(links, function (link) { observer.observe(link); });
  }

  function arm() {
    var links = document.querySelectorAll('[data-preferred-source]');
    if (!links.length) return;
    var start = function () { loadWhenNear(links); };
    if (window.tptConsent) window.tptConsent('analytics', start);
    else start();
  }

  function afterLoadAndIdle(fn) {
    var idle = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 4000 });
      else setTimeout(fn, 2000);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-preferred-source]');
    if (!link) return;
    var placement = link.getAttribute('data-preferred-source');
    report('click', placement);
    if (!api) return; // Google's script isn't loaded (or not allowed): the link opens Google's page.
    event.preventDefault();
    watchOutcome(placement);
    api.addPreferredSource();
  });

  afterLoadAndIdle(arm);
})();
